var _defs, _circle, _circle2, _g, _circle3, _circle4, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path3, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _polygon, _polygon2, _g2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeteran2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ring",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e6ebf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#9aa6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6c7787"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "face",
    cx: 0.35,
    cy: 0.28,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f8fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dde3ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#ffffff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 97,
    fill: "url(#ring)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 97,
    fill: "none",
    stroke: "#6c7787",
    strokeWidth: 2.5,
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e6ebf2",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186.3,
    cy: 117.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.2,
    cy: 148.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 173.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 186.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8,
    cy: 186.3,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 173.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 148.9,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 117.2,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 82.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 51.1,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 26.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8,
    cy: 13.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.2,
    cy: 13.7,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 26.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.2,
    cy: 51.1,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.3,
    cy: 82.8,
    r: 3.1
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 79,
    fill: "url(#face)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 79,
    fill: "none",
    stroke: "#6c7787",
    strokeWidth: 2,
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 21 100 A 79 79 0 0 1 179 100 Z",
    fill: "url(#gloss)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 44 148 Q 26 96 60 52",
    fill: "none",
    stroke: "#6c7787",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 148,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(60 44.0 148.0)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.9,
    cy: 127.5,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(46 38.9 127.5)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.9,
    cy: 107.7,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(32 37.9 107.7)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1,
    cy: 88.5,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(18 41.1 88.5)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 69.9,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(4 48.5 69.9)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(-10 60.0 52.0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 156 148 Q 174 96 140 52",
    fill: "none",
    stroke: "#6c7787",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156,
    cy: 148,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(-60 156.0 148.0)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.1,
    cy: 127.5,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(-46 161.1 127.5)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.1,
    cy: 107.7,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(-32 162.1 107.7)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.9,
    cy: 88.5,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(-18 158.9 88.5)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.5,
    cy: 69.9,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(-4 151.5 69.9)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 52,
    rx: 11,
    ry: 5.6,
    fill: "#e6ebf2",
    stroke: "#6c7787",
    strokeWidth: 1.4,
    transform: "rotate(10 140.0 52.0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "89.5,31.5 91.7,36.9 97.6,37.4 93.1,41.2 94.5,46.9 89.5,43.8 84.5,46.9 85.9,41.2 81.4,37.4 87.3,36.9",
    fill: "#6c7787",
    stroke: "#e6ebf2",
    strokeWidth: 1.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.5,31.5 112.7,36.9 118.6,37.4 114.1,41.2 115.5,46.9 110.5,43.8 105.5,46.9 106.9,41.2 102.4,37.4 108.3,36.9",
    fill: "#6c7787",
    stroke: "#e6ebf2",
    strokeWidth: 1.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,98) scale(0.68)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 31,
    rx: 43,
    ry: 9.5,
    fill: "#c05f00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 29,
    rx: 43,
    ry: 9.5,
    fill: "#e07f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -34 29 L -8.5 -46 Q 0 -52.5 8.5 -46 L 34 29 Z",
    fill: "#ff9911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -50.6 L 8.5 -46 L 34 29 L 0 29 Z",
    fill: "#e07f00",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -21.7 -6 L 21.7 -6 L 26.5 8 L -26.5 8 Z",
    fill: "#f4f4f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -6 L 21.7 -6 L 26.5 8 L 0 8 Z",
    fill: "#d9d9de",
    opacity: 0.55
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 172,
    textAnchor: "middle",
    fontFamily: "Arial Black, Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#5c6673",
    letterSpacing: 0.6
  }, "2 ROKY")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeteran2);
export default __webpack_public_path__ + "static/media/veteran-2.8a569dca274433f6209e6e4cb5ce5b2b.svg";
export { ForwardRef as ReactComponent };